import * as stylex from "@stylexjs/stylex";

const styles = stylex.create({
  target: {
    position: "relative",
  },
  hapticInput: {
    position: "absolute",
    inset: 0,
    zIndex: 10,
    width: "100%",
    height: "100%",
    cursor: "pointer",
    opacity: 0,
    pointerEvents: { default: null, ":disabled": "none" },
  },
});

const DirectHapticTarget = ({
  accessibleLabel,
  children,
  disabled,
  onActivate,
  style,
  styles: styleOverrides,
}: DirectHapticTargetProps) => {
  const targetProps = stylex.props(styles.target, styleOverrides);

  return (
    <span {...targetProps} style={{ ...targetProps.style, ...style }}>
      {children}
      <input
        aria-label={accessibleLabel}
        checked={false}
        disabled={disabled}
        onChange={onActivate}
        onClick={(event) => event.stopPropagation()}
        ref={(inputElement) => {
          inputElement?.setAttribute("switch", "");
        }}
        role="button"
        {...stylex.props(styles.hapticInput)}
        style={{ appearance: "auto" }}
        type="checkbox"
      />
    </span>
  );
};

DirectHapticTarget.displayName = "DirectHapticTarget";

export { DirectHapticTarget };
